
import { Vue, Component, Prop } from 'vue-property-decorator';
import SskAktifDetay from './SskAktifDetay.vue';
import BagkurAktifDetay from './BagkurAktifDetay.vue';
import KamuAktifDetay from './KamuAktifDetay.vue';
import SskEmekliDetay from './SskEmekliDetay.vue';
import BagkurEmekliDetay from './BagkurEmekliDetay.vue';
import KamuEmekliDetay from './KamuEmekliDetay.vue';
import IsyeriDetay from './IsyeriDetay.vue';
import SorguKaynakRozeti from "@/components/eicrapro/sorgu/SorguKaynakRozeti.vue";
import {
  SigortaSekmeAlani,
  sigortaKaynakBul,
  sigortaEslesikAlanlar,
  SIGORTA_KAYNAKLARI,
  sekmeGorunurSonraki,
  gecerliSorguCevabiMi
} from "./sigortaKaynaklari";
import { sskEmekliKayitlari } from '@/plugins/uyap-plugin/uyap/SskEmekli';

@Component({
  components: {
    SskAktifDetay,
    BagkurAktifDetay,
    KamuAktifDetay,
    SskEmekliDetay,
    BagkurEmekliDetay,
    KamuEmekliDetay,
    IsyeriDetay,
    SorguKaynakRozeti
  }
})
export default class BorcluSigortaBilgileri extends Vue {
  @Prop() borclu!: any;
  /** DEV-3344: ücretli Yenile'nin günlük hak diyaloğu için — bkz. UcretliSorguOnayDialog. */
  @Prop() dosyaId!: string | number;

  activeTab = 0;

  // DEV-3344: sekme başına ayrı yükleniyor bayrağı — bir sekmenin Yenile'si
  // diğerini kilitlemesin (bankaBilgileriniYenile tek alan olduğu için tek
  // bayrak yeterliydi, burada 7 alan var).
  yenileniyor: Record<SigortaSekmeAlani, boolean> = {
    ssk: false,
    sgkbagkur: false,
    sgkkamu: false,
    emekliSsk: false,
    emekliBagkur: false,
    emekliKamu: false,
    sgkIsyeri: false
  };

  /**
   * DEV-3344 (B23 — çürütücü bulgusu, orta öncelik): sekme görünürlüğü "şu an
   * veri var mı" yerine "veri HİÇ geçerli oldu mu" sorusuna bağlı. Yenile
   * artık CANLI bir cevapla borclu.<alan>'ı değiştirebiliyor; en az 4 sorgu
   * sınıfı (SgkKamu, BagkurEmekli, SskEmekli parse()) UYAP "kayıt bulunamadı"
   * derse HATA FIRLATMADAN sorguSonucu=false yazıyor. Eski hasXXXData
   * getter'ları doğrudan borclu.<alan>'ı okuduğu için, kullanıcı tam
   * Yenile'ye bastığı an o sekme (ve üzerindeki Yenile düğmesi) hiçbir uyarı
   * olmadan DOM'dan kayboluyordu — Banka kartındaki showTalep/bankaHacziSelected
   * parite hedefiyle çelişiyordu (o, sorgu sonucuna değil forma bağlı, hep
   * görünür kalır). Bu değerler yalnız false->true yönünde güncellenir (||),
   * asla true->false'a dönmez: bir sekme bir kez görünür olduysa bileşen
   * ömrü boyunca görünür kalır.
   *
   * DEV-3344 (B23 düzeltme turu 2 — çürütücü bulgusu x2, orta öncelik):
   * created()'ta TEK seferlik hesaplama iki gerçek senaryoda yetersiz
   * kalıyordu:
   *   1) emekliSsk/emekliKamu çiftinde `yenile()` aynı taze cevabı `$set` ile
   *      HER İKİ borclu.<alan>'a birden yazıyor (bkz. sigortaEslesikAlanlar).
   *      Mount anında biri geçersizken (TopluHacizHazirlaTaskHandler iki
   *      alanı AYRI sıralı UYAP isteğiyle sorguluyor, biri throw edip diğeri
   *      dönebilir) diğeri geçerliyse, kullanıcı GÖRÜNEN sekmeyi yenilediğinde
   *      GİZLİ sekmenin verisi de taze yazılıyordu ama tek seferlik görünürlük
   *      hiç güncellenmediği için o sekme asla belirmiyordu.
   *   2) Bu bileşen bir `v-dialog` (NewFormDialog) içinde render ediliyor;
   *      Vuetify'nin Bootable mixin'i dialog kapansa da içeriği YOK ETMİYOR
   *      (isBooted bir kez true olunca hep true kalır) — dış toggle
   *      (`borcluSigortaBilgileriToggle`) true kaldığı sürece bu bileşen
   *      YENİDEN OLUŞTURULMUYOR, yani created() bir daha ÇALIŞMIYOR. Verinin
   *      `yenile()` DIŞINDA bir yoldan (görevin sigorta sorgularını tekrar
   *      koşması gibi) SONRADAN tamamlanması durumunda, tek-seferlik hesap bu
   *      güncellemeyi hiç göremezdi.
   * Bu yüzden aşağıdaki created()'ta artık `this.$watch(...)` ile CANLI
   * izleniyor — sekme bileşen ömrü boyunca "sticky ama canlıya duyarlı":
   * ilk true'dan sonra hep true, ama ilk mount'ta false olan bir alan
   * SONRADAN geçerli hâle gelirse (kim yazarsa yazsın: bu bileşenin kendi
   * yenile()'si veya dışarıdan) watch bunu yakalar ve sekme belirir.
   */
  sekmeGorunurlugu: Record<SigortaSekmeAlani, boolean> = {
    ssk: false,
    sgkbagkur: false,
    sgkkamu: false,
    emekliSsk: false,
    emekliBagkur: false,
    emekliKamu: false,
    sgkIsyeri: false
  };

  created() {
    // Watch'a bir STRING path yerine FONKSİYON verilmesi bilinçli: Vue önce
    // `this.borclu`'yu (prop) sonra `tanim.cevapSec` içindeki `borclu.<alan>`'ı
    // okur; `<alan>` mount anında borclu üzerinde hiç yoksa bile `this.borclu`
    // okuması Vue'nun "childOb.dep" bağımlılığını kurar — `Vue.set`/`this.$set`
    // tam olarak bu dep'i bildirdiği için (Vue 2 reaktivite sınırının bilinen
    // istisnası), ileride `yenile()`nin `$set` ile İLK KEZ eklediği bir alan
    // da bu watch'ı tetikler; alan zaten borclu üzerinde varsa ekstra bir şey
    // gerekmez.
    for (const tanim of SIGORTA_KAYNAKLARI) {
      this.$watch(
        () => tanim.cevapSec(this.borclu),
        (cevap: any) => {
          this.sekmeGorunurlugu[tanim.alan] = sekmeGorunurSonraki(
            this.sekmeGorunurlugu[tanim.alan],
            cevap,
            (c: any) => this.sekmeVeriVarMi(tanim.alan, c)
          );
        },
        {immediate: true}
      );
    }
  }

  /**
   * Sekmenin cevabı "veri var" sayılır mı? Varsayılan kural `gecerliSorguCevabiMi`;
   * iki emekli sekmesi develop'taki DEV-3514 kurallarını ekler:
   *  - SSK emeklisi: "Aylık Ödenmemektedir" cevabında sorguSonucu false gelir ama
   *    emekli kaydı vardır; sekme yine gösterilir.
   *  - Kamu emeklisi: eski görevlerde emekliKamu, SskEmekli cevabının kopyasıdır
   *    (sorgulamaTuru "SSK Emeklisi"); aynı kayıt Kamu Emeklisi sekmesinde ikinci
   *    kez görünmez.
   */
  sekmeVeriVarMi(alan: SigortaSekmeAlani, cevap: any): boolean {
    if (alan === "emekliSsk") {
      return gecerliSorguCevabiMi(cevap) || sskEmekliKayitlari(cevap?.sorguSonucDVO).length > 0;
    }
    if (alan === "emekliKamu") {
      return gecerliSorguCevabiMi(cevap) && cevap.sorgulamaTuru !== "SSK Emeklisi";
    }
    return gecerliSorguCevabiMi(cevap);
  }

  alanAdi(alan: SigortaSekmeAlani): string {
    return sigortaKaynakBul(alan)?.alanAdi ?? "";
  }

  /**
   * DEV-3344 (B23 düzeltme turu — çürütücü bulgusu, orta öncelik): rozete ve
   * detay bileşenine verilen KÖK cevap nesnesi artık şablonda hardcoded
   * `borclu.<alan>` yerine `sigortaKaynaklari.ts`deki `cevapSec` üzerinden
   * okunuyor — testlerin (`sigortaKaynaklari.spec.ts`) doğruladığı yol ile
   * bileşenin GERÇEKTE çalıştırdığı yol artık aynı; ileride bir sekmeye
   * yanlış `borclu.<alan>` bağlanırsa testler bunu yakalar.
   */
  kaynakSec(alan: SigortaSekmeAlani): any {
    return sigortaKaynakBul(alan)?.cevapSec(this.borclu);
  }

  /**
   * DEV-3344 — `bankaBilgileriniYenile` deseninin 7 sekmeye genellenmiş hâli.
   * Sorgu `sigortaKaynaklari.ts` tablosundan `.fresh()` ile koşulur (hem
   * IndexedDB'yi hem snapshot katmanını atlar); cevap `borclu.<alan>`'a
   * REAKTİF olarak yazılır. `borclu`, ebeveyn formun `localValue`'su ile AYNI
   * nesne referansı (bu bileşen kendi kopyasını çıkarmıyor) — ama o `localValue`
   * da ObjectInputMixin'de üst prop'un SIĞ kopyası olduğu için `$emit("input")`
   * ile ebeveynin kendi `input()`'unu tetiklemek şart: yoksa değişiklik yalnız
   * bu ekranda görünür, form yukarı doğru yeniden emit edilmezse bir sonraki
   * `value` değişiminde ESKİ veriye dönülüp veri kaybı yaşanır (bkz.
   * TopluHacizTalepDuzenleForm.vue `bankaBilgileriniYenile`).
   *
   * Cevabın yazılacağı alanları `sigortaEslesikAlanlar` verir. DEV-3344'te
   * 'emekliSsk' ile 'emekliKamu' aynı `SskEmekli` isteğini koştuğu için ikisine
   * birden yazılıyordu; DEV-3514 (develop) ile kamu emeklisi ayrı `KamuEmekli`
   * servisine geçti ve her alan yalnız kendi cevabını alıyor. `created()`deki
   * `$watch` yazılan alanın `sekmeGorunurlugu`sunu kendiliğinden günceller.
   */
  async yenile(alan: SigortaSekmeAlani) {
    if (this.yenileniyor[alan]) {
      return;
    }
    const tanim = sigortaKaynakBul(alan);
    if (!tanim) {
      return;
    }
    const eslesikAlanlar = sigortaEslesikAlanlar(alan);
    for (const a of eslesikAlanlar) {
      this.yenileniyor[a] = true;
    }
    try {
      const cevap = await tanim.sorguKosustur(this.$uyap, {
        dosyaId: this.dosyaId,
        kisiKurumId: (this.borclu as any)?.kisiKurumId
      });
      for (const a of eslesikAlanlar) {
        this.$set(this.borclu, a, cevap);
      }
      this.$emit("input");
    } catch (e: any) {
      this.$toast.error(e.message || `${tanim.alanAdi} sorgusu yenilenemedi.`);
    } finally {
      for (const a of eslesikAlanlar) {
        this.yenileniyor[a] = false;
      }
    }
  }

  get borcluAdi() {
    if (this.borclu.borcluBilgileri) {
      // DosyaBorclu tipinde
      if (this.borclu.borcluBilgileri.adi) {
        return `${this.borclu.borcluBilgileri.adi} ${this.borclu.borcluBilgileri.soyadi}`;
      } else if (this.borclu.borcluBilgileri.kurumAdi) {
        return this.borclu.borcluBilgileri.kurumAdi;
      }
    }
    return 'Borçlu';
  }

  // DEV-3344 (B23 düzeltme turu): bu getter'lar artık CANLI borclu.<alan>'ı
  // değil, mount anında bir kez hesaplanan sekmeGorunurlugu'nu okuyor —
  // gerekçe için created() ve sekmeGorunurlugu tanımındaki yorumlara bakın.
  get hasSskData() {
    return this.sekmeGorunurlugu.ssk;
  }

  get hasBagkurData() {
    return this.sekmeGorunurlugu.sgkbagkur;
  }

  get hasKamuData() {
    return this.sekmeGorunurlugu.sgkkamu;
  }

  // DEV-3514 kuralı sekmeVeriVarMi'de ("Aylık Ödenmemektedir" kaydı da sekme açar).
  get hasEmekliSskData() {
    return this.sekmeGorunurlugu.emekliSsk;
  }

  get hasEmekliBagkurData() {
    return this.sekmeGorunurlugu.emekliBagkur;
  }

  // DEV-3514 kuralı sekmeVeriVarMi'de (eski görevlerdeki SSK emekli kopyası sayılmaz).
  get hasEmekliKamuData() {
    return this.sekmeGorunurlugu.emekliKamu;
  }

  get hasIsyeriData() {
    return this.sekmeGorunurlugu.sgkIsyeri;
  }

  // Herhangi bir veri var mı?
  get hasAnyData() {
    return this.hasSskData ||
           this.hasBagkurData ||
           this.hasKamuData ||
           this.hasEmekliSskData ||
           this.hasEmekliBagkurData ||
           this.hasEmekliKamuData ||
           this.hasIsyeriData;
  }
}
